// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hotel-brand-logo--artifact-fix[data-v-5b90f7fe]{filter:brightness(1.14) contrast(1.1)}.brands-marquee[data-v-5b90f7fe]{animation:brands-scroll-5b90f7fe 18s linear infinite;width:-moz-max-content;width:max-content}@keyframes brands-scroll-5b90f7fe{0%{transform:translateX(0)}to{transform:translateX(-50%)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
